/**
 * This component displays topic badges for projects and catalog resources.
 */ import { GlBadge, GlPopover, GlTooltipDirective } from '@gitlab/ui';
import { uniqueId } from 'lodash-es';
import { topicExploreProjectsPath } from '~/lib/utils/path_helpers/explore';
import { s__, sprintf } from '~/locale';
import { truncate } from '~/lib/utils/text_utility';
const MAX_TOPICS_TO_SHOW = 3;
const MAX_TOPIC_TITLE_LENGTH = 15;
export default {
    name: 'TopicBadges',
    i18n: {
        topics: s__('Topics|Topics'),
        topicsPopoverTargetText: s__('Topics|+%{count} more'),
        moreTopics: s__('Topics|More topics')
    },
    components: {
        GlBadge,
        GlPopover
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        showLabel: {
            type: Boolean,
            required: false,
            default: true
        },
        topics: {
            type: Array,
            required: true
        }
    },
    emits: [
        'click'
    ],
    data () {
        return {
            topicsPopoverTarget: uniqueId('project-topics-popover-')
        };
    },
    computed: {
        visibleTopics () {
            return this.topics.slice(0, MAX_TOPICS_TO_SHOW);
        },
        collapsedTopics () {
            return this.topics.slice(MAX_TOPICS_TO_SHOW);
        },
        popoverText () {
            return sprintf(s__('Topics|+%{count} more'), {
                count: this.collapsedTopics.length
            });
        }
    },
    methods: {
        topicPath (topic) {
            return topicExploreProjectsPath(topic);
        },
        topicTitle (topic) {
            return truncate(topic, MAX_TOPIC_TITLE_LENGTH);
        },
        topicTooltipTitle (topic) {
            const wasTruncated = topic !== this.topicTitle(topic);
            if (wasTruncated) {
                return topic;
            }
            return null;
        }
    }
};
